module.exports = __webpack_public_path__ + "static/media/CSSimage.5b9a5d83.png";